module.exports = __webpack_public_path__ + "img/about1.9d5ee9ef.jpg";